const form = () => {
  const fillFileList = input => {
    if (input.files) {
      const list = input.parentElement.parentElement.parentElement.querySelector(
        '.js-input-file-list',
      );
      list.innerHTML = '';
      for (let i = 0; i < input.files.length; i++) {
        list.innerHTML = `${
          list.innerHTML
        }<li class="o-list-bare__item c-filelist__item">
              <span class="c-filelist__title">${input.files[i].name}</span>
              <span class="js-input-file-item-delete c-filelist__delete">&times;</span>
          </li>`;
      }
      const elems = document.querySelectorAll('.js-input-file-item-delete');
      for (let i = 0; i < elems.length; i++) {
        const elem = elems[i];
        if (elem) {
          elem.addEventListener('click', e => {
            e.target.parentElement.remove();
          });
        }
      }
    }
  };
  const elems = document.querySelectorAll('.js-input-file');
  for (let i = 0; i < elems.length; i++) {
    const elem = elems[i];
    if (elem) {
      elem.addEventListener('change', e => {
        fillFileList(e.target);
      });
    }
  }
  if (document.querySelector('.js-more-info-trigger')) {
    document
      .querySelector('.js-more-info-trigger')
      .addEventListener('click', event => {
        event.preventDefault();
        event.target.remove();
        document.querySelector('.js-more-info').classList.add('is-active');
      });
  }
};

export default form;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/form.js